import React from "react";
import { useDispatch } from "react-redux";
import { TextField, Grid } from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import { createRetirementDefinitionAction, modifyRetirementDefinitionAction } from "../../actions";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import useHandleForm from "./useHandleForm";
import useIsSocietyCountry from "@icarius-app/components/wrapper/hooks/useIsSocietyCountry";
import CustomNumberFormat from "@icarius-common/dynamicInputs/customNumberFormat";

const gridStyle = { height: 75, padding: "0px 10px" };

const Form = (props) => {
    const { data, handleClose } = props;
    const dispatch = useDispatch();
    const isChile = useIsSocietyCountry("CL");
    const isPeru = useIsSocietyCountry("PE");

    const create = (dataToSend) => {
        dispatch(createRetirementDefinitionAction(dataToSend)).then((res) => res?.status === 200 && handleClose());
    };

    const modify = (dataToSend) => {
        dispatch(modifyRetirementDefinitionAction(dataToSend)).then((res) => res?.status === 200 && handleClose());
    };

    const openValidationError = () => {
        dispatch(openSnackbarAction({ msg: getLocalizedString("invalidData"), severity: "error", duration: 10000 }));
    };

    const { isCreate, formData, setFormValue, submit } = useHandleForm(data, create, modify, openValidationError);

    return (
        <Grid container item xs={12} direction="row" style={{ paddingTop: 10 }}>
            <Grid container item xs={12}>
                <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
                    <TextField
                        disabled={!Boolean(isCreate)}
                        required
                        fullWidth
                        margin={"none"}
                        label={getLocalizedString("centerCode")}
                        onChange={(e) => setFormValue(e.target.value, "code")}
                        value={formData.code}
                        inputProps={{ maxLength: 8 }}
                    />
                </Grid>
                <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
                    <TextField
                        required
                        fullWidth
                        margin={"none"}
                        label={getLocalizedString("name")}
                        value={formData.name}
                        onChange={(e) => setFormValue(e.target.value, "name")}
                        inputProps={{ maxLength: 60 }}
                    />
                </Grid>
                <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
                    <TextField
                        fullWidth
                        margin={"none"}
                        label={getLocalizedString("institutionCode")}
                        value={formData.institutionCode}
                        onChange={(e) => setFormValue(e.target.value, "institutionCode")}
                        inputProps={{ maxLength: 12 }}
                    />
                </Grid>
                {isChile && (
                    <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
                        <TextField
                            required
                            fullWidth
                            InputProps={{ inputComponent: CustomNumberFormat }}
                            margin={"none"}
                            label={getLocalizedString("previredCode")}
                            value={formData.previredCode}
                            onChange={(e) => setFormValue(e.target.value, "previredCode")}
                            inputProps={{ maxLength: 3, min: 0, decimals: 0 }}
                        />
                    </Grid>
                )}
                {isPeru && (
                    <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
                        <TextField
                            fullWidth
                            margin={"none"}
                            InputProps={{ inputComponent: CustomNumberFormat }}
                            label={getLocalizedString("afpCode")}
                            value={formData.afpCode}
                            onChange={(e) => setFormValue(e.target.value, "afpCode")}
                            inputProps={{ maxLength: 2, min: 0, decimals: 0 }}
                        />
                    </Grid>
                )}
                {isChile && (
                    <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
                        <TextField
                            fullWidth
                            InputProps={{ inputComponent: CustomNumberFormat }}
                            margin={"none"}
                            label={getLocalizedString("lreCode")}
                            value={formData.lreCode}
                            onChange={(e) => setFormValue(e.target.value, "lreCode")}
                            inputProps={{ maxLength: 3, min: 0, decimals: 0 }}
                        />
                    </Grid>
                )}
                <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
                    <TextField
                        fullWidth
                        InputProps={{ inputComponent: CustomNumberFormat }}
                        margin={"none"}
                        label={getLocalizedString("mandatoryPercentage")}
                        value={formData.mandatoryPercentage}
                        onChange={(e) => setFormValue(e.target.value, "mandatoryPercentage")}
                        inputProps={{ min: "0", step: "0.01", decimals: 2 }}
                    />
                </Grid>
                <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
                    <TextField
                        fullWidth
                        InputProps={{ inputComponent: CustomNumberFormat }}
                        margin={"none"}
                        label={getLocalizedString("disabilityInsurance")}
                        value={formData.disabilityInsurance}
                        onChange={(e) => setFormValue(e.target.value, "disabilityInsurance")}
                        inputProps={{ min: "0", step: "0.01", decimals: 2 }}
                    />
                </Grid>
                {isChile && (
                    <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
                        <TextField
                            fullWidth
                            InputProps={{ inputComponent: CustomNumberFormat }}
                            margin={"none"}
                            label={getLocalizedString("commission")}
                            value={formData.retirementPercentage}
                            onChange={(e) => setFormValue(e.target.value, "retirementPercentage")}
                            inputProps={{ min: "0", step: "0.01", decimals: 2 }}
                        />
                    </Grid>
                )}
                {isPeru && (
                    <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
                        <TextField
                            fullWidth
                            InputProps={{ inputComponent: CustomNumberFormat }}
                            margin={"none"}
                            label={getLocalizedString("variableCommission")}
                            value={formData.variableCommission}
                            onChange={(e) => setFormValue(e.target.value, "variableCommission")}
                            inputProps={{ min: "0", step: "0.01", decimals: 2 }}
                        />
                    </Grid>
                )}
                {isPeru && (
                    <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
                        <TextField
                            fullWidth
                            InputProps={{ inputComponent: CustomNumberFormat }}
                            margin={"none"}
                            label={getLocalizedString("balanceCommission")}
                            value={formData.balanceCommission}
                            onChange={(e) => setFormValue(e.target.value, "balanceCommission")}
                            inputProps={{ min: "0", step: "0.01", decimals: 2 }}
                        />
                    </Grid>
                )}
            </Grid>
            <Grid container item xs={12} justify={"flex-end"} alignItems="center" style={{ paddingBottom: 20 }}>
                <ButtonDialogAction isAccept onClick={submit} text={getLocalizedString("save")} />
            </Grid>
        </Grid>
    );
};

export default Form;
